module.exports = __webpack_public_path__ + "static/media/bg_speaker_controls.3d54c24f.png";